<template>
  <div>
    <Head title="Außenbereich" />
    <section class="overflow-hidden text-gray-700 py-3">
      <ul>
        <li v-for="(image, index) in images" :key="index">
          <h2>{{ image.description }}</h2>
          <div class="w-full p-1 md:p-2">
            <img :src="image.src" :width="image.thumbnailWidth" class="block object-cover object-center w-full h-full rounded-lg shadow-md shadow-gray-500" />
          </div>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

import 'vue-silentbox/dist/style.css'

export default {
  components: {
    Head,
  },
  layout: Layout,

  data() {
    return {
      images: [
        {
          description: 'Außenbereich mit Hängematte und Sitzecke',
          src: this.$page.props.cdn_url + 'rs,s:1024/fewo_vogelschar__aussenbereich_04.jpg',
          thumbnailWidth: '1024',
        },
        {
          description: 'Hängematte zum Entspannen',
          src: this.$page.props.cdn_url + 'rs,s:1024/fewo_vogelschar__aussenbereich_01.jpg',
          thumbnailWidth: '1024',
        },
        {
          description: 'Sitzecke mit Grill und Feuerschale',
          src: this.$page.props.cdn_url + 'rs,s:1024/fewo_vogelschar__aussenbereich_02.jpg',
          thumbnailWidth: '1024',
        },
      ],
      lightboxList: [],
      lightboxIndex: 0,
    }
  },
  methods: {
    openLightbox: function (list, index) {
      this.lightboxList = list
      this.lightboxIndex = index
    },
  },
}
</script>
